import { render, staticRenderFns } from "./metasVentaDinero.vue?vue&type=template&id=2457ba11&scoped=true"
import script from "./metasVentaDinero.vue?vue&type=script&lang=js"
export * from "./metasVentaDinero.vue?vue&type=script&lang=js"
import style0 from "./metasVentaDinero.vue?vue&type=style&index=0&id=2457ba11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457ba11",
  null
  
)

export default component.exports